import { useEffect, useState } from "react";
import Cookies from "js-cookie";

export function usePermissions() {
  const [permissions, setPermissions] = useState<string[] | null>(null);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [permissionLoading, setPermissionLoading] = useState(true);

  useEffect(() => {
    try {
      const permissionsData = localStorage.getItem("Permissions");
      const currentUserData = Cookies.get("currentUser");

      const parsedPermissions = permissionsData
        ? JSON.parse(permissionsData)
        : [];

      const parsedUser = currentUserData
        ? JSON.parse(currentUserData)
        : null;

      const permissionList = parsedPermissions
        .map((p: any) => p?.SystemName)
        .filter(Boolean);

      setPermissions(permissionList);
      setCurrentUser(parsedUser);
    } catch (error) {
      console.error("Permission parsing error:", error);
      setPermissions([]);
      setCurrentUser(null);
    } finally {
      setPermissionLoading(false);
    }
  }, []);

  return { permissions, currentUser, permissionLoading };
}